var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _ro, _settleId, _dk, _mb, _wrapper, _target, _onBreakpoint, _update, _JumboText_instances, listen_fn, getLines_fn;
import { l as lazyInit, j as findOptimalFontSize } from "./utilities-2Suih3Nm.js";
const _mq = matchMedia("(max-width: 991px)");
class JumboText extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _JumboText_instances);
    __privateAdd(this, _ro);
    __privateAdd(this, _settleId, null);
    __privateAdd(this, _dk, null);
    // { width, fontSize }
    __privateAdd(this, _mb, null);
    // { width, fontSize }
    __privateAdd(this, _wrapper);
    // cached closest('jumbo-text-component')
    __privateAdd(this, _target);
    /** On breakpoint cross, re-evaluate with a short debounce */
    __privateAdd(this, _onBreakpoint, () => {
      clearTimeout(__privateGet(this, _settleId));
      __privateSet(this, _settleId, setTimeout(() => __privateGet(this, _update).call(this), 50));
    });
    __privateAdd(this, _update, () => {
      const wrapper = __privateGet(this, _wrapper) ?? __privateSet(this, _wrapper, this.closest("jumbo-text-component"));
      const target = __privateGet(this, _target) ?? __privateSet(this, _target, wrapper || this);
      const isMb = _mq.matches;
      const cache = isMb ? __privateGet(this, _mb) : __privateGet(this, _dk);
      const containerWidth = wrapper ? wrapper.offsetWidth : this.parentElement.offsetWidth;
      if (cache && containerWidth === cache.width) {
        this.classList.add("active");
        __privateMethod(this, _JumboText_instances, listen_fn).call(this);
        return;
      }
      target.style.removeProperty("--jt-fs-dk");
      target.style.removeProperty("--jt-fs-mb");
      target.style.fontSize = "";
      const lines = __privateMethod(this, _JumboText_instances, getLines_fn).call(this);
      if (!containerWidth || !lines.length) {
        this.classList.add("active");
        __privateMethod(this, _JumboText_instances, listen_fn).call(this);
        return;
      }
      const style = getComputedStyle(this);
      const longest = lines.reduce((a, b) => a.length > b.length ? a : b);
      let fontSize = findOptimalFontSize(longest, containerWidth, style);
      if (wrapper && lines.length > 1) {
        const maxHeight = parseFloat(getComputedStyle(wrapper).maxHeight);
        if (maxHeight) {
          const lh = parseFloat(style.lineHeight) / parseFloat(style.fontSize) || 1;
          const heightBasedSize = maxHeight / (lines.length * lh);
          fontSize = Math.min(fontSize, heightBasedSize);
        }
      }
      if (isMb) __privateSet(this, _mb, { width: containerWidth, fontSize });
      else __privateSet(this, _dk, { width: containerWidth, fontSize });
      target.style.setProperty(isMb ? "--jt-fs-mb" : "--jt-fs-dk", `${fontSize}px`);
      this.classList.add("active");
      __privateMethod(this, _JumboText_instances, listen_fn).call(this);
    });
  }
  // wrapper || this
  connectedCallback() {
    __privateSet(this, _ro, new ResizeObserver(() => {
      clearTimeout(__privateGet(this, _settleId));
      __privateSet(this, _settleId, setTimeout(() => __privateGet(this, _update).call(this), 150));
    }));
    lazyInit(this, () => {
      document.fonts.ready.then(() => requestAnimationFrame(() => __privateGet(this, _update).call(this)));
    });
  }
  disconnectedCallback() {
    var _a;
    (_a = __privateGet(this, _ro)) == null ? void 0 : _a.disconnect();
    clearTimeout(__privateGet(this, _settleId));
    _mq.removeEventListener("change", __privateGet(this, _onBreakpoint));
  }
}
_ro = new WeakMap();
_settleId = new WeakMap();
_dk = new WeakMap();
_mb = new WeakMap();
_wrapper = new WeakMap();
_target = new WeakMap();
_onBreakpoint = new WeakMap();
_update = new WeakMap();
_JumboText_instances = new WeakSet();
/** Start observing resize + breakpoint changes (idempotent) */
listen_fn = function() {
  __privateGet(this, _ro).observe(this);
  _mq.addEventListener("change", __privateGet(this, _onBreakpoint));
};
/** Extract text lines by splitting on <br> elements */
getLines_fn = function() {
  const lines = [];
  let current = "";
  for (const node of this.childNodes) {
    if (node.nodeName === "BR") {
      const trimmed2 = current.trim();
      if (trimmed2) lines.push(trimmed2);
      current = "";
    } else {
      current += node.textContent || "";
    }
  }
  const trimmed = current.trim();
  if (trimmed) lines.push(trimmed);
  return lines;
};
if (!customElements.get("jumbo-text")) {
  customElements.define("jumbo-text", JumboText);
}
